import { render, staticRenderFns } from "./BaseQuestionResponse.vue?vue&type=template&id=1399bb4f&scoped=true&"
import script from "./BaseQuestionResponse.vue?vue&type=script&lang=js&"
export * from "./BaseQuestionResponse.vue?vue&type=script&lang=js&"
import style0 from "./BaseQuestionResponse.vue?vue&type=style&index=0&id=1399bb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1399bb4f",
  null
  
)

export default component.exports